<res-base-modal [modalTitle]="'Settings'" [modalClass]="modalClass" [modalAutomationId]="modalAutomationId"
    (closeButtonActionEmt)="closeModal()" [modalHelpIndex]="modalHelpIndex" [showButtonBar]=false
    [modalDraggable]=false>

    <ul class="nav nav-tabs">
        <li [hidden]="hideCaseSettings" [ngClass]="{'active': settingsType === 'project' }" id="projectSettingsId"
            [attr.data-automation-id]="modalAutomationId + '-project-settings-button'"
            (click)="setSettingsType('project')">
            <a><i class="fa fa-cogs color-blue-01"></i>Project Settings</a>
        </li>
        <li [ngClass]="{'active': settingsType === 'organization' }" id="organizationSettingsId"
            [attr.data-automation-id]="modalAutomationId + '-organization-settings-button'"
            (click)="setSettingsType('organization')" [hidden]="hideOrgSettings">
            <a><i class="fa fa-cogs color-yellow-07"></i>Organization Settings</a>
        </li>
        <li [ngClass]="{'active': settingsType === 'system' }"
            [attr.data-automation-id]="modalAutomationId + '-system-settings-button'"
            (click)="setSettingsType('system')" *ngIf="showSystemSettings">
            <a><i class="fa fa-cogs color-purple-03"></i>System Settings</a>
        </li>
        <span [hidden]="settingsType === 'system'" class="context-name">{{settingsType === 'project' ?
            (currentProject.name + (currentProject.description ? (' - ' + currentProject.description)
            : '')) : currentOrganization}}</span>
    </ul>
    <div class="content">
        <div id="leftSettingContent">
            <res-generic-tree #settingsTree
                customClasses="generic-tree-navigation-header-panels generic-tree-header-panels-chevron-expanders generic-tree-header-panel-border-top generic-tree-border-bottom-left-radius"
                [automationId]="(settingsType === 'project' ? 'proj-' : (settingsType === 'organization' ? 'org-': 'system-')) + 'settings-tree'"
                [preselectNodeCallback]="preselectSettingCallback"
                [onContextMenuActionCallback]="onContextMenuActionCallback">
            </res-generic-tree>
        </div>
        <res-resizer anchor="left" resizingElementId="leftSettingContent" secondElementId="middleSettingContent"
            [collapsible]="true" [initSize]="220" [maxSize]="400" collapsedIcon="fa-sitemap"
            collapsedTitle="Show Settings Tree"></res-resizer>
        <div id="middleSettingContent">
            <div *ngIf="selectedSetting && selectedSetting.requestInfo" id="selectedSettingList"
                [resBusySpinner]="itemListIsBusy" [message]="itemListIsBusyMessage">
                <res-generic-tree #selectedSettingTree [initialData]="selectedSettingNodes"
                    customClasses="generic-tree-navigation-header-panels generic-tree-header-panels-chevron-expanders generic-tree-header-panel-border-top generic-tree-border-bottom-left-radius"
                    automationId="selected-setting-tree" [preselectNodeCallback]="preselectSettingChildCallback"
                    [onContextMenuActionCallback]="onContextMenuActionCallback">
                </res-generic-tree>
            </div>
            <res-resizer *ngIf="selectedSetting && selectedSetting.requestInfo" anchor="left"
                resizingElementId="selectedSettingList" secondElementId="navigationSettingContent" [initSize]="260"
                [minSize]="100" [maxSize]="400" [ellipsisExpander]="true"></res-resizer>
            <div id="navigationSettingContent">
                <router-outlet name="settings-router-outlet" (activate)="onRouterOutletActivate($event)">
                </router-outlet>
            </div>
        </div>
    </div>
    <a download #downloadLink hidden target="_blank"></a>
</res-base-modal>